<script>
import { merchantComputed } from '@store/helpers'
import dialog2Mixin from "../mixins/dialog2";

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      storeList: [] // [{ title: '民生店', alias: 'aaa' }]
    }
  },
  computed: {
    ...merchantComputed,
    phoneNumber() {
      return this.storeItem.phoneNumber || this.currentMerchant.phoneNumber
    },
    storeTitle() {
      return this.storeItem.title || this.currentMerchant.title
    },
  },
  methods: {
    formatLineId(lineId = '') {
      return lineId.replace('@', '')
    },
    formatPhonenumber(phonenumber = '') {
      const [code, number] = phonenumber.split('-');

      return number
        ? phonenumber
        : ''
    }
  }
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${ $style.dialogContact } isStyleLogin text-center`"
    width="378px"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogContact__title">聯繫我們</div>
    <div class="dialogContact__content">
      如您有任何需求
      <br>(例如：取消預約、更動預約時間)
      <br>請撥打下方電話直接聯繫，
      <br>我們將竭誠為您服務。
    </div>
    <template v-for="(storeItem, index) in storeList">
      <div v-if="formatPhonenumber(storeItem.phoneNumber)" class="text-center my-4">
      <span>
        <BaseButton
          class="isStylePrimary isText"
          :href="`tel:${ formatPhonenumber(storeItem.phoneNumber) }`"
        >
          <i class="fontello fontello-phone mr-2 fa-lg text-primary"></i>
          <span>{{ storeItem.title }}: {{ formatPhonenumber(storeItem.phoneNumber) }}</span>
        </BaseButton>
      </span>
      </div>
      <div v-if="storeItem.lineId" class="text-center my-4">
        <span>
          <i class="fontello fontello-line-solid mr-2 fa-lg text-primary"></i>
          <span>{{ storeItem.title }}: @{{ formatLineId(storeItem.lineId) }}</span>
        </span>
      </div>
    </template>
    <BaseButton
      class="isStylePrimary isRadius isFull"
      @click="dialog2MixinVisible = false"
    >
      我瞭解了
    </BaseButton>
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogContact {
  :global {
    .dialogContact {
      &__title {
        margin-bottom: 1.5rem;
        font-family:$font-title;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
        color: $color-primary-dark;
      }

      &__content {
        font-size: 0.875rem;
        line-height: 2;
        color: $color-gray-2;
      }
    }
  }
}
</style>
